import {asArray} from "../../../../utils/input";
import React from "react";
import TypeaheadSearch from "../../TypeaheadSearch";
import closeGrey from "../../../../icons/close_grey2.svg";
import magnifier from "../../../../icons/maginifier.svg";
import {TypeAheadSearchFocusProps} from "../props";

const FocusableTypeAhead = ({
  minCharacters,
  options,
  search,
  placeholder,
  bgPlaceholder,
  notFoundText,
  hideSuggestions,
  onSearchChange,
  onInputKeyUp,
  onInputKeyDown,
  focusableRef,
  onClickInput,
  selectorClass = 'empty-box__container',
}: TypeAheadSearchFocusProps) => {
  const optionsList = asArray(options) as string[];
  const focusedBgClass = placeholder === bgPlaceholder ? 'focused-box__bg uppercase' : 'focused-box__bg';

  return (
    <div className={selectorClass} ref={focusableRef as React.RefObject<HTMLDivElement>} data-testid="header-search-box">
      <div className="focused-box__wrapper">
        <div className={focusedBgClass}>
          <img src={magnifier} alt="magnifier" className="focused-box__bg-magnifier" />
          <span>{bgPlaceholder}</span>
        </div>
        <TypeaheadSearch
          minCharacters={minCharacters}
          options={optionsList}
          search={search}
          placeholder={placeholder}
          notFoundText={notFoundText}
          closeIcon={closeGrey}
          hideSearchIcon={false}
          hideClearButton={false}
          hideSuggestions={hideSuggestions}
          onKeyDown={onInputKeyDown}
          onKeyUp={onInputKeyUp}
          inputType="search"
          role="searchbox"
          enterKeyHint="search"
          onClickInput={onClickInput}
          onSearchChange={onSearchChange}
        />
      </div>
    </div>
  );
}
export {FocusableTypeAhead}